import { getEnumeration } from 'enumeration'
import { pointLimitType } from 'json'
import { formatDate } from '@/utils/formUtils'
import timeutils from 'utils/wt-time-utils'
export function handleIntegralTsk (pointsTask) {
  // 单次积分
  pointsTask.unitAndValue = pointsTask.value ? `+${pointsTask.value}分/${pointsTask.unit || '次'}` : '--'
  // 上限类型
  pointsTask.limitTypeCopy = getEnumeration(pointsTask.limitType, pointLimitType)
  // 上限次数
  pointsTask.limitTimesCopy = pointsTask.limitTimes ? `${pointsTask.limitTimes}次` : '--'
  // 发布时间
  pointsTask.createdDateCopy = pointsTask.lastModifiedDate ? formatDate(pointsTask.lastModifiedDate) : '--'
  // 状态
  pointsTask.statusCopy = pointsTask.status === 'ENABLED' ? '执行中' : '已暂停'
}
export default {
  membersPointsDetails (data) {
    data.forEach(item => {
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
      item.hasDetail = item.businessType === 'pay_order_integral_mall' || item.businessType === 'refund_order_integral_mall'
      if (item.changeType === 'INCREASE_POINTS') {
        item.value = `+${item.value}`
      } else {
        item.value = `-${item.value}`
      }
    })
    return data
  }
}
